(function () {
    'use strict';

    angular
        .module('surveyCampaignsModule')
        .controller('SurveyCampaignQuestionnaireListEditController', Controller);

    Controller.$inject = ['$scope', '$state', 'externalParty', 'campaign'];

    function Controller($scope, $state, externalParty, campaign) {
        $scope.externalParty = externalParty;
        $scope.campaign = campaign;

        $scope.goToExternalParty = function () {
            $state.go('odd.externalPartyEdit');
        };

        $scope.goToCampaign = function () {
            $state.go('odd.externalPartyEdit.campaign', { ODDCampaignID: campaign.ODDCampaignID }, { reload: true });
        };

        $scope.goToCampaigns = function () {
            $state.go('odd.surveyCampaigns', { ODDBusinessUnitID: $scope.campaign.ODDBusinessUnitID }, { reload: true });
        };
    }
})();